// Shared types for 13-month calendar system

export type YearStartMode = 'fixed' | 'lunar';

export interface Calendar13Config {
  yearStartMode: YearStartMode;
  lunarReferenceDate: string;
  leapYearRule: 'none' | 'gregorian' | 'custom';
  customLeapYearOffset?: number;
  fixedStartDate?: { month: number; day: number };
  epochYear?: number;
}

export const DEFAULT_CONFIG: Calendar13Config = {
  yearStartMode: 'fixed',
  fixedStartDate: { month: 7, day: 26 },
  epochYear: 1987,
  lunarReferenceDate: '2000-01-06',
  leapYearRule: 'gregorian',
};

export interface Day13 {
  year: number;
  month: number;
  day: number;
  weekday: number;
  isOutOfTime?: boolean;
  isLeapDay?: boolean;
  gregorianDate?: Date;
}

export interface Month13 {
  number: number;
  name: string;
  glyph?: string;
  days: Day13[];
}

export const MONTH_NAMES: { number: number; name: string; glyph?: string }[] = [
  { number: 1,  name: 'Magnetic',     glyph: '🌑' },
  { number: 2,  name: 'Lunar',        glyph: '🌒' },
  { number: 3,  name: 'Electric',     glyph: '⚡' },
  { number: 4,  name: 'Self-Existing',glyph: '🔲' },
  { number: 5,  name: 'Overtone',     glyph: '🔊' },
  { number: 6,  name: 'Rhythmic',     glyph: '🥁' },
  { number: 7,  name: 'Resonant',     glyph: '📡' },
  { number: 8,  name: 'Galactic',     glyph: '🌌' },
  { number: 9,  name: 'Solar',        glyph: '☀️' },
  { number: 10, name: 'Planetary',    glyph: '🌍' },
  { number: 11, name: 'Spectral',     glyph: '🌈' },
  { number: 12, name: 'Crystal',      glyph: '💎' },
  { number: 13, name: 'Cosmic',       glyph: '✨' },
];

export const WEEKDAY_NAMES = [
  'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'
];

// 7 Radion Plasmas that repeat 4× in each 28-day moon
// Day position within moon (1-based) → PLASMA_NAMES[(day - 1) % 7]
export const PLASMA_NAMES: { name: string; short: string; chakra: string }[] = [
  { name: 'Dali',  short: 'Dal', chakra: 'Crown'   },
  { name: 'Seli',  short: 'Sel', chakra: 'Root'    },
  { name: 'Gamma', short: 'Gam', chakra: '3rd Eye'  },
  { name: 'Kali',  short: 'Kal', chakra: 'Secret'  },
  { name: 'Alpha', short: 'Alp', chakra: 'Throat'  },
  { name: 'Limi',  short: 'Lim', chakra: 'Solar'   },
  { name: 'Silio', short: 'Sil', chakra: 'Heart'   },
];
